import PageLayout from '../components/PageLayout'
import Seo from '../components/Seo'

export default function Privacy() {
  return (
    <PageLayout title="Gizlilik Politikası ve KVKK Aydınlatma Metni">
      <Seo title="Gizlilik ve KVKK" />
      <div className="space-y-8 text-gray-300">
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">1. Veri Sorumlusu</h2>
          <p>6698 sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) uyarınca, Saatbahane olarak, veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan amaçlar kapsamında işlemekteyiz.</p>
        </section>
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">2. Kişisel Verilerin İşlenme Amacı</h2>
          <p>Toplanan kişisel verileriniz; ürün ve hizmetlerimizden faydalanmanız, taleplerinizin karşılanması, iletişim faaliyetlerinin yürütülmesi ve yasal yükümlülüklerin yerine getirilmesi amaçlarıyla işlenmektedir.</p>
        </section>
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">3. Kişisel Verilerin Aktarılması</h2>
          <p>Kişisel verileriniz, yasal düzenlemelerin öngördüğü hallerde yetkili kamu kurum ve kuruluşlarına aktarılabilecektir.</p>
        </section>
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">4. İletişim</h2>
          <p>KVKK kapsamındaki haklarınız ve talepleriniz için <a href="mailto:info@saatbahane.com" className="text-gold-500 transition-colors hover:text-gold-400">info@saatbahane.com</a> adresi üzerinden bizimle iletişime geçebilirsiniz.</p>
        </section>
        <div className="mt-8 border-t border-white/10 pt-8">
          <p className="text-sm italic opacity-60">Son Güncelleme: Ocak 2026</p>
        </div>
      </div>
    </PageLayout>
  )
}

